import { QuoteEventType } from '../enums/quoteEventType'

export const quoteSentStatusEvents = [
  QuoteEventType.DeliveryEmailSent,
  QuoteEventType.DeliveryManualSent,
  QuoteEventType.DocumentSent,
]
